import { useState } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import {
  columnTextField,
  columnNumberField,
  columnPriceField,
  columnDateField,
  chaveNFFormatter,
  columnBooleanField,
} from "utils/tables-utils";
import Api from "lib/api/httpRequestHelper";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import DialogOcorrenciasTransporte from "./dialog-ocorrencias-transporte";
import { FindInPage, GetApp, LocalShipping } from "@mui/icons-material";

const getFileInvoice = async (tipo, chave) => {
  return await Api.get(tipo, "invoice", "?chaveNf=" + chave, false)
    .then((value) => {
      const url =
        "data:application/octet-stream;base64," + value.Result.FileBase64;
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.target = "_blank";
      downloadLink.download = chave + "." + tipo;
      downloadLink.click();
    })
    .catch((error) => {
      console.log(error);
    });
};

export default function PedidoDetailsNFs({ NFs }) {
  const [selectedRowForOcorrencias, setSelectedRowForOcorrencias] =
    useState(null);
  const [ocorrenciasDialogOpen, setOcorrenciasDialogOpen] = useState(false);

  const handleOpenOcorrenciasDialog = (row) => {
    setSelectedRowForOcorrencias(row);
    setOcorrenciasDialogOpen(true);
  };

  const handleCloseOcorrenciasDialog = () => {
    setOcorrenciasDialogOpen(false);
    setSelectedRowForOcorrencias(null);
  };

  const nfsColumnModel = [
    columnNumberField({
      dataField: "NumeroNf",
      text: "Nota fiscal",
    }),
    columnTextField({
      dataField: "SerieNf",
      text: "Série",
      align: "center",
    }),
    columnDateField({
      dataField: "DataEmissaoNf",
      text: "Data Emissão",
    }),
    columnTextField({
      dataField: "StatusNf",
      text: "Status",
      align: "center",
    }),
    columnPriceField({
      dataField: "ValorTotalNf",
      text: "Valor Total",
      align: "end",
    }),
    columnTextField({
      dataField: "ChaveNf",
      text: "Chave da NF",
      align: "center",
      formatter: (_, row) => {
        return chaveNFFormatter(row.ChaveNf);
      },
    }),
    columnBooleanField({
      dataField: "Entregue",
      text: "Entregue",
    }),
    columnDateField({
      dataField: "DataPrevisaoEntrega",
      text: "Data Previsão Entrega",
    }),
    columnTextField({
      dataField: "rastreio",
      text: "Rastreio",
      align: "center",
      formatter: (_, row) => (
        <Tooltip title="Ver Rastreio">
          <IconButton
            size="small"
            onClick={() => {
              row?.LinkRastreio
                ? window.open(row.LinkRastreio, "_blank")
                : handleOpenOcorrenciasDialog(row);
            }}
          >
            <LocalShipping fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    }),
    columnTextField({
      dataField: "consulta",
      text: "Consulta Sefaz",
      align: "center",
      formatter: (_, row) => (
        <Tooltip title="Consultar Sefaz">
          <IconButton
            onClick={() => {
              window.open(
                "https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=resumo&nfe=" +
                  row.ChaveNfe,
                "_blank"
              );
            }}
            size="small"
          >
            <FindInPage fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    }),
    columnTextField({
      dataField: "XmlNoS3",
      text: "XML",
      align: "center",
      formatter: (_, row) => (
        <Tooltip title="Download XML">
          <IconButton
            size="small"
            onClick={(e) => getFileInvoice("xml", row.ChaveNfe)}
          >
            <GetApp fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    }),
    columnTextField({
      dataField: "PdfNoS3",
      text: "PDF",
      align: "center",
      formatter: (_, row) => (
        <Tooltip title="Download PDF">
          <IconButton
            size="small"
            onClick={(e) => getFileInvoice("pdf", row.ChaveNfe)}
          >
            <GetApp fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    }),
  ];

  return (
    <>
      <ToolkitTable
        dataTable={NFs}
        columnModel={nfsColumnModel}
        keyField="NumeroNf"
        pagination={false}
        style={{
          boxShadow: "none",
        }}
      />
      <DialogOcorrenciasTransporte
        open={ocorrenciasDialogOpen}
        onClose={handleCloseOcorrenciasDialog}
        chaveNf={selectedRowForOcorrencias?.ChaveNf}
        numero={selectedRowForOcorrencias?.NumeroNf}
        serie={selectedRowForOcorrencias?.SerieNf}
      />
    </>
  );
}
